'use strict'

import Helper from '@/utils/helper'
import FileInfo from '@/app/service/api/model/common/file-info'

const DEFAULT_DURATION_SEC = 30

class AdItem {
  constructor ({ type, regionCode, screenOrientation, url, displayFrequency, file, duration, volumeLevel }) {
    Helper.checkInt('AdTextItem.type', type)
    Helper.checkString('AdTextItem.regionCode', regionCode)
    Helper.checkInt('AdTextItem.screenOrientation', screenOrientation)

    if (Helper.isDefined(url)) {
      Helper.checkString('AdTextItem.url', url)
    }

    Helper.checkInt('AdTextItem.displayFrequency', displayFrequency)
    if (Helper.isDefined(duration)) {
      Helper.checkInt('AdTextItem.duration', duration)
    }

    if (Helper.isDefined(volumeLevel)) {
      Helper.checkInt('AdTextItem.volumeLevel', volumeLevel)
    }

    if (Helper.isDefined(file)) {
      this.file = new FileInfo(file)
    }

    this.type = type
    this.regionCode = regionCode
    this.screenOrientation = screenOrientation
    this.displayFrequency = displayFrequency

    this.url = Helper.isDefined(url) ? url : null
    this.duration = Helper.isDefined(duration) ? duration : DEFAULT_DURATION_SEC
    this.volumeLevel = Helper.isDefined(volumeLevel) ? (volumeLevel / 100) : null
  }

  getType () {
    return this.type
  }

  isExternalSource () {
    return this.type === 2
  }

  getRegionCode () {
    return this.regionCode
  }

  getScreenOrientation () {
    return this.screenOrientation
  }

  isVerticalOrientation () {
    return this.screenOrientation === 0
  }

  isHorizontalOrientation () {
    return this.screenOrientation === 1
  }

  getUrl () {
    return this.url
  }

  getDisplayFrequency () {
    return this.displayFrequency
  }

  getFile () {
    return this.file
  }

  getDuration () {
    return this.duration
  }

  getVolume () {
    return this.volumeLevel
  }

  toString () {
    return 'AdItem{' +
      ', type=' + '\'' + this.type + '\'' +
      ', regionCode=' + '\'' + this.regionCode + '\'' +
      ', screenOrientation=' + '\'' + this.screenOrientation + '\'' +
      ', url=' + '\'' + this.url + '\'' +
      ', displayFrequency=' + '\'' + this.displayFrequency + '\'' +
      ', file=' + '\'' + this.file + '\'' +
      ', duration=' + '\'' + this.duration + '\'' +
      ', volumeLevel=' + '\'' + this.volumeLevel + '\'' +
      '}'
  }
}

export default AdItem
